export default "__VITE_ASSET__CajsPG_n__"